import { render, staticRenderFns } from "./yjfkDetail.vue?vue&type=template&id=6bc55e19&scoped=true&"
import script from "./yjfkDetail.vue?vue&type=script&lang=js&"
export * from "./yjfkDetail.vue?vue&type=script&lang=js&"
import style0 from "./yjfkDetail.vue?vue&type=style&index=0&id=6bc55e19&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc55e19",
  null
  
)

export default component.exports